import { cx } from 'class-variance-authority';
import Link from 'next/link';
import { useTranslations } from 'next-intl';

import { EventType } from '@/analytics/types';
import { useWizardStateContext } from '@/app/[locale]/product/_contexts/WizardStateProvider';
import getBreadcrumbs, {
  type Breadcrumb,
} from '@/app/[locale]/product/_utils/getBreadcrumbs';

const Tabs = () => {
  const { currentRoute, currentStep } = useWizardStateContext();
  const breadcrumbs: Breadcrumb[] = getBreadcrumbs(currentRoute);
  const t = useTranslations();

  const handleTabClick = async (step: string, href: string) => {
    await window.ouraAnalytics.track(EventType.LinkClicked, {
      cta: 'return_to_prev_step',
      location: step,
      path: href,
    });
  };

  return (
    <div className="flex grow justify-around">
      {breadcrumbs.map(({ enumVal, title, href, isValid }, index) => {
        const step = index + 1;

        return (
          <Link
            className={cx(
              'flex flex-wrap content-end justify-around overflow-hidden text-sandstone-500',
              'mt-4 px-1 pb-4 lg:mt-6 lg:pb-6',
              'h-10 lg:h-12',
              {
                'border-b border-sandstone-500 font-semibold':
                  currentStep === enumVal,
                'pointer-events-none cursor-default text-sandstone-500/30':
                  !isValid,
              },
            )}
            data-cy={`${enumVal}-tab`}
            href={href}
            key={t(title)}
            tabIndex={isValid ? 0 : -1}
            onClick={() => handleTabClick(currentStep, `${href}`)}
          >
            <span>{step}. </span>
            <span className="truncate">{t(title)}</span>
          </Link>
        );
      })}
    </div>
  );
};

export default Tabs;
